import React from 'react';

import { ArrowRightIcon } from "@heroicons/react/solid";
import { Link } from 'react-scroll';

export default function Navbar() {
  return (
    <header className="bg-gray-800 sticky top-0 z-20">
      <div className="container max-w-screen-xl px-4 md:px-8 mx-auto flex flex-wrap py-5 flex-col md:flex-row items-center">
        <a className="title-font font-medium text-white mb-4 md:mb-0" href="https://sampom100.github.io/testPages/">
          <Link activeClass="active" to="about" spy={true} smooth={true} >
            <a href="https://sampom100.github.io/testPages/" lassName="text-xl">
              Sam Pomerantz
            </a>
          </Link>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
          <Link activeClass="active" to="education" spy={true} smooth={true}>
            <a href="#education" className="mx-4 hover:text-white">
              Education
            </a>
          </Link>
          <Link activeClass="active" to="experience" spy={true} smooth={true}>
            <a href="#experience" className="mx-4 hover:text-white">
              Experience
            </a>
          </Link>
          <Link activeClass="active" to="projects" spy={true} smooth={true}>
            <a href="#projects" className="mx-4 mb-4 hover:text-white">
              Projects
            </a>
          </Link>
          <Link activeClass="active" to="news" spy={true} smooth={true}>
            <a href="#news" className="mx-4 mb-4 hover:text-white">
              News
            </a>
          </Link>
        </nav>
      </div>
    </header>
  );
}
//<a
//href="https://www.sampom100.github.io/testPages/" target="_blank"
//className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0">
//Old Website
//<ArrowRightIcon className="w-4 h-4 ml-1" />
//</a>